export default function PageConfirmacao() {
    return (
        <div className="confirmation-body confirmation-background">
            <div className="confirmation-message-container">
                <div className="confirmation-message-ball confirmation-background">
                    <i className="bi bi-check2 confirmation-icon"></i>
                </div>
                <p className="confirmation-message-text">Inscrição confirmada!</p>
            </div>
        </div>
    );
}